import { Activity, useEffect, useState } from 'react'
import { BotoAra, TabsBar } from '@diariara/ara-ui'
import HeaderEmbed from '@common/HeaderEmbed'
import Input from './components/input'
import '@diariara/ara-ui/dist/index.css'
import '@common/reset.css'
import './style.scss'

export default function App({ embedHome, lang, preview, slug }) {
	/**************************/
	// Si cal afegir dades del CMS
	const [dadesCMS, setDadesCMS] = useState(null)

	useEffect(() => {
		// Si tenim un slug, podem fer la consulta al CMS per obtenir les dades associades a aquest widget
		fetch(`${process.env.API_CLIENT}/embeds/v1/calculadora-nota-tall`)
			.then((res) => res.json())
			.then((json) => setDadesCMS(json.data))
			.catch((error) => console.log(error))
	}, [])
	/**************************/

	const [estudis, setEstudis] = useState('batxillerat')
	const [feedback, setFeedback] = useState(0)
	const [resultat, setResultat] = useState(null)

	const formatNota = (nota) => nota.toFixed(2).replace('.', ',')

	const handleReset = () => {
		const form = document.getElementById('calculadora-nota-tall-form')
		form.reset()
		setResultat(null)
		setFeedback(0)
	}

	const handleSubmit = (event) => {
		event.preventDefault()
		const formData = new FormData(event.target)
		const data = Object.fromEntries(
			Array.from(formData.entries(), ([key, value]) => {
				const numericValue = Number.parseFloat(value) || 0
				return [key, Math.round(numericValue * 100) / 100]
			}),
		)

		const {
			nota_estudis,
			catala,
			castella,
			estrangera,
			historia,
			optativa,
			especifica1,
			especifica2,
			especifica1_pondera,
			especifica2_pondera,
		} = data

		if (estudis === 'fp') {
			if (nota_estudis < 5) {
				setFeedback(3)
			} else {
				const nota = nota_estudis + especifica1 * especifica1_pondera + especifica2 * especifica2_pondera
				setFeedback(1)
				setResultat(formatNota(nota))
			}
		} else {
			if (nota_estudis < 5) {
				setFeedback(2)
			} else if ((catala + castella + estrangera + historia + optativa) / 5 < 4) {
				setFeedback(4)
			} else {
				const notaGeneral =
					0.6 * nota_estudis + 0.4 * ((catala + castella + estrangera + historia + optativa) / 5)
				const notaEspecifica = especifica1 * especifica1_pondera + especifica2 * especifica2_pondera

				if (notaGeneral < 4.999) {
					setFeedback(5)
					setResultat(formatNota(notaGeneral))
				} else {
					setFeedback(1)
					setResultat(formatNota(notaGeneral + notaEspecifica))
				}
			}
		}
	}

	const handleEstudis = (key) => {
		handleReset()
		setEstudis(key)
	}

	return (
		<>
			<Activity mode={preview ? 'visible' : 'hidden'}>
				<HeaderEmbed allowHomeEmbed={false} />
			</Activity>
			<form id='calculadora-nota-tall-form' onSubmit={handleSubmit}>
				<p className='e3 titol'>{dadesCMS?.titol}</p>
				<header>
					<TabsBar
						tabs={[
							{
								actiu: true,
								keyTab: 'batxillerat',
								type: 'button',
								handleClick: handleEstudis,
								text: dadesCMS?.batxillerat,
							},
							{
								actiu: false,
								keyTab: 'fp',
								type: 'button',
								handleClick: handleEstudis,
								text: dadesCMS?.fp,
							},
						]}
					/>
				</header>

				<div>
					<Input
						name='nota_estudis'
						min='0'
						max='10'
						text={estudis === 'fp' ? dadesCMS?.nota_fp : dadesCMS?.nota_batxillerat}
					/>
				</div>
				{estudis === 'batxillerat' && (
					<div>
						<p className='e4'>{dadesCMS?.fase_general}</p>
						<Input name='catala' min='0' max='10' text={dadesCMS?.catala} />
						<Input name='castella' min='0' max='10' text={dadesCMS?.castella} />
						<Input name='estrangera' min='0' max='10' text={dadesCMS?.estrangera} />
						<Input name='historia' min='0' max='10' text={dadesCMS?.historia} />
						<Input name='optativa' min='0' max='10' text={dadesCMS?.optativa} />
					</div>
				)}
				<div>
					<p className='e4'>{dadesCMS?.fase_especifica}</p>
					<Input name='especifica1' min='0' max='10' text={dadesCMS?.especifica1} pondera />
					<Input name='especifica2' min='0' max='10' text={dadesCMS?.especifica2} pondera />
				</div>

				<footer>
					<div>
						{feedback === 5 ? (
							<p className='e5 negatiu'>
								{`${dadesCMS?.feedback5} ${resultat} ${dadesCMS?.feedback5_2}`}
							</p>
						) : (
							<p className='e5 negatiu' style={{ opacity: feedback > 1 ? 1 : 0 }}>
								{dadesCMS?.[`feedback${feedback}`]}
							</p>
						)}
					</div>
					<BotoAra type='submit'>{dadesCMS?.calcular}</BotoAra>
				</footer>
				{feedback === 1 && (
					<div className='feedback'>
						<p className='e4'>{dadesCMS?.[`feedback${feedback}`]}</p>
						{feedback === 1 && <span className='e5'>{resultat}</span>}
						<p className='nota e8' dangerouslySetInnerHTML={{ __html: dadesCMS?.nota }} />
					</div>
				)}
			</form>
		</>
	)
}
